module.exports = __webpack_public_path__ + "img/phone.94960918.png";